import { LitElement, html } from 'lit';
import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { globalStyle } from '../../global-styles.style.js';
import { style } from './key-requirements.style.js';
import { stratum } from '../../../constants/stratum.js';

export class RefiKeyRequirements extends LitElement {
  static styles = [style, globalStyle];

  closeModal() {
    this.shadowRoot.getElementById('qualificationModal').closeModalDialog();
  }

  render() {
    return html`
      <fs-modal-dialog
        id="qualificationModal"
        accessible-title="qualificationModal"
        dismissible
        size="small"
        slot="sub-header"
        @modal-dialog-open="${() => {
          stratum.publishTag(TagKey.PERSONAL_NAME_VIEW_ELIGIBILITY_MODAL);
          trackAnalyticsEvent(TagKey.PERSONAL_NAME_VIEW_ELIGIBILITY_MODAL);
        }}"
      >
        <fs-button variant="primary" type="button" compact ghost id="open">
          View key eligibility requirements
        </fs-button>
        <refi-heading slot="modal-dialog-header">
          Key eligibility requirements
        </refi-heading>
        <section
          class="fs-body-text fs-body-text--normal qualification-modal-body-text"
          slot="modal-dialog-body"
        >
          <fs-body-text size="normal" variant="primary"
            >To pre-qualify:</fs-body-text
          >
          <fs-body-text size="normal" variant="primary"
            >Your current auto loan must have at least 18 months remaining and a
            balance of $7,500 or more. It also can't be from Capital One.
          </fs-body-text>
          <fs-body-text size="normal" variant="primary"
            >Your vehicle must be a car, truck, minivan, or SUV intended for
            personal use. It also can't have a model year older than 10 years.
          </fs-body-text>
          <fs-heading level="2" size="small" variant="primary">
            See our
            <eligibility-link
              @click="${() => {
                this.closeModal();
                stratum.publishTag(
                  TagKey.PQ_TEXT_INPUT_FIELD_VIEW_FULL_ELIGIBILITY_REDIRECT
                );
                trackAnalyticsEvent(
                  TagKey.PQ_TEXT_INPUT_FIELD_VIEW_FULL_ELIGIBILITY_REDIRECT
                );
              }}"
              inline="true"
            >
              full eligibility requirements and product terms.
            </eligibility-link>
          </fs-heading>
        </section>
        <fs-modal-dialog-footer slot="modal-dialog-footer">
          <fs-button
            @click=${this.closeModal}
            type="button"
            class="fs-button fs-button--primary"
          >
            Okay
          </fs-button>
        </fs-modal-dialog-footer>
      </fs-modal-dialog>
    `;
  }
}

customElements.define('refi-key-requirements', RefiKeyRequirements);
